/**
 * To convert the attribute values of an object from string numbers to numbers.
 *
 * Examples:
 *
 *  "8474"  --> 8474
 *  "8478k" --> "8478k" (no conversion because input is a string)
 *  ["111", "222", "333"] --> [111, 222, 333]
 *  ["111", "222", "333a"] --> ["111", "222", "333a"] (no conversion because input is a string)
 *
 * @param obj
 */

export const deepConvertNumericStringsToNumbers = (obj: any): void => {
  for (const key in obj) {
    if (Array.isArray(obj[key])) {
      // check if all elements are either numeric strings or null.
      const allNumericOrNulls = obj[key].every(
        (value: any) => (typeof value === 'string' && value.match(/^\d+$/)) || value === null,
      );

      if (allNumericOrNulls) {
        // convert numeric strings to numbers, leave nulls as is.
        obj[key] = obj[key].map((value: any) => (typeof value === 'string' ? parseInt(value, 10) : value));
      }
      // if not all elements are numeric strings or nulls, no conversion is performed, leaving the array as is.
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      // recursive call for nested objects
      deepConvertNumericStringsToNumbers(obj[key]);
    } else if (typeof obj[key] === 'string' && obj[key].match(/^\d+$/)) {
      // convert numeric strings to numbers for non-array, non-null objects.
      obj[key] = parseInt(obj[key], 10);
    }
  }
};
